import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles } from '@/styles';
@customElement('fg-aria-live')
export class FgAriaLive extends LitElement {
  @property({ type: String })
  announcement = '';

  @property({ type: String })
  type: 'off' | 'polite' | 'assertive' = 'polite';

  render() {
    return html`
      <span class="sr-only" aria-live="${this.type}" aria-atomic="true">
        ${this.announcement}
      </span>
    `;
  }

  static styles = [baseStyles];
}
